import * as React from 'react';

import {IntegrationWidget} from 'shells/integration-widget/integration-widget';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

import type {ExternalServiceType} from 'nutshell-graphql-types';
import type {GetSessionUser_loggedInUser as User} from 'nutshell-graphql-types';

import {getServiceTypeIcon, getServiceNoun, getRecordingRequiredMessage} from '../../helpers';
import {TranscriptionModePicker} from '../../transcription-mode-picker';

type Props = {
    isConnected: boolean;
    isEnabled: boolean;
    userEmail: string;
    isLoading: boolean;
    refetchIntegration: () => Promise<any>;
    setPageAutoPrevious: (arg1: boolean) => void;
    serviceType: ExternalServiceType;
    user: User;
    onEnableClick: () => void;
    onDisableClick: () => void;
};

export function Connected(props: Props) {
    if (props.isLoading) {
        return (
            <div className='absolutely-center-and-fill'>
                <LoadingPage />
            </div>
        );
    }

    return (
        <OnboardingBody title={`Your ${getServiceNoun(props.serviceType)} account is connected`}>
            <div className='my-16'>
                <StackLegacy spacing={32}>
                    <IntegrationWidget
                        status={props.isEnabled ? 'enabled' : 'disabled'}
                        account={props.userEmail}
                        actionStyle={props.serviceType === 'GOOGLE_MEET' ? 'switch' : 'button'}
                        initialText={`Connect to ${getServiceNoun(props.serviceType)}`}
                        logo={getServiceTypeIcon(props.serviceType)}
                        onConnectClick={props.onEnableClick}
                        disabled={props.isConnected}
                        onlyDisconnect={true}
                        onDisconnectClick={() => {
                            Promise.resolve(props.onDisableClick()).then(() => {
                                if (
                                    props.serviceType === 'ZOOM' ||
                                    props.serviceType === 'MICROSOFT_TEAMS'
                                ) {
                                    props.refetchIntegration();
                                    props.setPageAutoPrevious(true);
                                }
                            });
                        }}
                    />
                    <TranscriptionModePicker serviceType={props.serviceType} user={props.user} />
                    {getRecordingRequiredMessage(props.serviceType)}
                </StackLegacy>
            </div>
        </OnboardingBody>
    );
}
